angular.module('rental')
    .controller('RentalResourceShowController', function ($scope, $uibModalInstance, data, RentalResourceConst, RentalResource, Principal) {
        this.$onInit = () => {
            this.item = data
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
        }
        this.cancel = () => $uibModalInstance.dismiss()
        $scope.$on(RentalResourceConst.eventUpdate, () => {
            RentalResource.get({id: this.item.id}).$promise.then(entity => this.item = entity)
        })
        $scope.$on(RentalResourceConst.eventDelete, () => $uibModalInstance.dismiss());
    })
